import { useState } from 'react'
import LoginForm from '../components/LoginForm.tsx'
import RegisterForm from '../components/RegisterForm'
import '../styles/authPage.css'

interface AuthPageProps {
  onSuccess?: () => void
}

export default function AuthPage({ onSuccess }: AuthPageProps) {
  const [activeTab, setActiveTab] = useState<'login' | 'register'>('login')

  const handleRegisterSuccess = () => {
    // Après l'inscription, rediriger vers l'onglet connexion
    setActiveTab('login')
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>🌹 MBOA Messenger</h1>
          <p>Communication professionnelle élégante</p>
        </div>

        <div className="auth-tabs">
          <button
            className={`${activeTab === 'login' ? 'active' : ''}`}
            onClick={() => setActiveTab('login')}
          >
            Connexion
          </button>
          <button
            className={`${activeTab === 'register' ? 'active' : ''}`}
            onClick={() => setActiveTab('register')}
          >
            Inscription
          </button>
        </div>

        {activeTab === 'login' ? (
          <LoginForm onSuccess={onSuccess} />
        ) : (
          <RegisterForm onSuccess={handleRegisterSuccess} />
        )}
      </div>
    </div>
  )
}
